module.exports = __webpack_public_path__ + "media/images/project/back-25c3045d19685e1148e3bc5650a5c61d.svg";